'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = {
  name: 'MenuDivider',
  props: {
    disabled: {
      type: Boolean,
      'default': true
    },
    rootPrefixCls: String
  },
  render: function render() {
    var h = arguments[0];
    var rootPrefixCls = this.$props.rootPrefixCls;
    return h('li', {
      'class': rootPrefixCls + '-item-divider'
    });
  }
};